import {
    type MutationAccountAddArgs,
    type MutationAccountRemoveArgs,
    type MutationAccountVerifyArgs,
    type QueryAccountsArgs,
} from '@pkg/graphql/codegen/graphql';
import accountAddMutation from '@pkg/graphql/mutations/accountAdd.graphql';
import accountRemoveMutation from '@pkg/graphql/mutations/accountRemove.graphql';
import accountVerifyMutation from '@pkg/graphql/mutations/accountVerify.graphql';
import { accounts } from '@pkg/graphql/queries';

import { type BaseParams, graphqlMutation, graphqlQuery } from '@app/client';

type RequestProps<T> = BaseParams & { variables: T };
type WalletByProps = RequestProps<QueryAccountsArgs & { withCollectibles?: boolean }>;

export const callGetAccounts = (params: WalletByProps) =>
    graphqlQuery({
        ...params,
        query: accounts,
    });

export const callAddWallet = (params: RequestProps<MutationAccountAddArgs>) =>
    graphqlMutation({
        ...params,
        query: accountAddMutation,
    });
export const callVerifyWallet = (params: RequestProps<MutationAccountVerifyArgs>) =>
    graphqlMutation({
        ...params,
        query: accountVerifyMutation,
    });
export const callRemoveWallet = (params: RequestProps<MutationAccountRemoveArgs>) =>
    graphqlMutation({
        ...params,
        query: accountRemoveMutation,
    });
